export enum NotesMode {
  VIEW,
  CREATE,
  EDIT
}

export enum NotesClickedFrom {
  LIST,
  PREVIEW
}
